import React, {
    ChangeEvent,
    FocusEvent,
    ForwardedRef,
    forwardRef,
    ForwardRefExoticComponent,
    PropsWithoutRef, RefAttributes
} from "react";

export type FormFieldProps<V> = {
    label?: string;
    name: string;
    value?: V;
    onChange?: (e: ChangeEvent) => void;
    onBlur?: (e: FocusEvent) => void;
    error?: string;
}

export type FormFieldRenderFunction<P extends FormFieldProps<V>,T,V> = (props: P, ref:ForwardedRef<T>) => React.JSX.Element;
export type DefinedFormField<P,T> =  ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>
export type DefinedFormFieldElement<P extends FormFieldProps<V> = FormFieldProps<any>,V = any,T = any> = React.ReactElement<PropsWithoutRef<P> & RefAttributes<T>>

export const defineFormField = <P extends FormFieldProps<V>,T,V>(render: FormFieldRenderFunction<P,T,V>):DefinedFormField<P, T> => {
    return forwardRef<T,P>(render);
}
